import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "../Button/Button";
import styles from "./ErrorFallback.module.css";

interface ErrorFallbackProps {
	message?: string;
	onRetry?: () => void;
}

export function ErrorFallback({ message, onRetry }: ErrorFallbackProps) {
	const { t } = useTranslation();
	return (
		<div className={styles.wrapper}>
			<AlertTriangle size={32} className={styles.icon} />
			<p className={styles.message}>{message || t("error")}</p>
			{onRetry && (
				<Button variant="secondary" onClick={onRetry}>
					{t("retry")}
				</Button>
			)}
		</div>
	);
}
